import { Component, Inject, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelperService } from '../../services/helper.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/api-services/user.service';
@Component({
  selector: 'app-add-reason-popup',
  templateUrl: './add-reason-popup.component.html',
  styleUrls: ['./add-reason-popup.component.scss']
})
export class AddReasonPopupComponent {
  warning: boolean = false;
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  disableButton: boolean;
  constructor(public dialogRef: MatDialogRef<AddReasonPopupComponent>,
    private fb: FormBuilder,
    public userService: UserService,
    public toast: ToastrService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any) {
    this.disableButton = false;
    this.initializeForm();
  }
  initializeForm() {
    this.form = this.fb.group({
      reason: new FormControl("", [Validators.required]),
    });
  }
  formSubmit() {
    if (this.form.valid) {
      let payload = {
        ...this.form.value,
        reason: this.form.value.reason
      }
      this.isLoading = true;
      this.disableButton = true;
      this.userService.save_rejected_reason(payload).subscribe(res => {
        this.isLoading = false;
        if (res.body.success) {
          this.dialogRef.close({ response: res.body });
          this.toast.success(res.body.message);
        }
        else {
          this.disableButton = false;
          this.toast.error(res.body.message);
        }
      })
    }
    else {
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }
}
